const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

// RN-T5: `entity` is a system-value code (an ErrorEntity of Sun, e.g. CLIENT); it is translated before interpolation,
// the code itself being the fallback (P9: no catalogue copy to read a factory word from).
const entityLabel = (i18n, entity) => i18n.t(entity, { defaultValue: entity })

/**
 * Story 204 — RN4.9: the message a coded error (C1 body) shows in the user's language, or '' when the body has no
 * code or the code has no key in any language (then `Api_Functions` keeps today's `message`). The chain
 * custom → base → en is i18next's own (`i18n.exists`/`i18n.t`); `message` is the fallback for a key without text.
 *
 * @param {{exists: function(string): boolean, t: function(string, Object=): string}} i18n The app's i18next instance
 * @param {*} body The parsed error body
 * @returns {string}
 */
export const codedErrorMessage = (i18n, body) => {
  if (!isPlainObject(body) || typeof body.code !== 'string' || body.code === '' || !i18n.exists(body.code)) return ''
  const params = isPlainObject(body.params) ? { ...body.params } : {}
  if (typeof params.entity === 'string') params.entity = entityLabel(i18n, params.entity)
  const text = i18n.t(body.code, { ...params, defaultValue: typeof body.message === 'string' ? body.message : '' })
  // C7 leaves a key whose text is the code itself (`en` = defaultText). That is no translation (RN-T3): the user never
  // sees the bare code, `Api_Functions` keeps Sun's message as for a code without key.
  return text === body.code ? '' : text
}
